import { BalanceSheetReportType } from "../types"

export const buildHierarchys = ( data: BalanceSheetReportType[], parentId: number | null): BalanceSheetReportType[] => {
  return data
    .filter((item) => item.parent_id === parentId)
    .map((item) => ({
      ...item,
      children: buildHierarchys(data, item.coa_id)
    }))
}